import React, { Component, Fragment } from "react";

//Component
import { tableHeader } from "../../services/common/options";
import QrCode from "../Common/QrCode";

class PrintStylePage extends Component {
  state = {
    selectedData: this.props.selectedData,
    column: this.props.column,
    tableHeaderData: this.props.tableHeaderData
  };
  
  componentWillReceiveProps = props => {
    this.setState({
      selectedData: props.selectedData,
      column: props.column,
      tableHeaderData: props.tableHeaderData
    });
  };

  render() {
    const { selectedData, column, tableHeaderData } = this.state;
  
    return (
      <Fragment>
        <div className="print-div">
          <style>
            {`@media print {

@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

                .w-100 {
                  width: 100%;
                }
                .print-h-w:not(:first-child) {
                  margin-top: 0px;
                }
                body {
                  font-family: 'Roboto', sans-serif;
                  font-size: 10px; 
                }
                .print-h-w {
                  box-sizing: border-box;
                  // max-height: 408px;
                  height: 99%;
                  width: 99%;
                  margin: 0 0 0 10px;
                  padding: 0;
                  border: 1px solid black;
                  page-break-after: always;
                  word-wrap: break-word;
                }
                .td-border {
                  border-bottom: 1px solid black;
                  width: 100%;
                }
                table > tbody > tr:nth-child(odd) {
                  background: transparent;
                }
                table > tbody > tr td {
                  font-size: 10px;
                  vertical-align: top;
                  padding: 0px!important;
                  margin: 0px!important;
                  max-width: 100%;
                }

                td > p {
                  padding: 0px!important;
                  margin: 2.5px 0px 0px 0px!important;
                }
                .border-bl {
                  border: 1px solid black;
                }
                .text-right {
                  text-align: right;
                }
                .text-left {
                  text-align: left;
                }
                .text-center {
                  text-align: center;
                }
                .text-center {
                  text-align: center;
                }
                .f-15 {
                  font-size: 10px;
                }
                .title-main {
                  padding: 0px 0px 3px 0px;
                }
                .qr-wrap {
                  padding: 0px;
                }
                .width-30 {
                  width: 20%;
                }
                .width-70 {
                  width: 80%;
                }

                .l-height {
                  line-height: 1.1
                }
              }
              @page {
                size: 3.98in 1.33in;
              }`}
          </style>
          <div class="table-container">
            {selectedData &&
              selectedData.length > 0 &&
              selectedData.map(val => {
                return (
                  <Fragment>
                    <div className="overflow print-h-w">
                      <table className="borderless-table w-100">
                        <tbody>
                          <tr>
                            <td colSpan="4" className="text-center td-border">
                              <div
                                className="title-main"
                                style={{
                                  margin: "0",
                                  padding: "0",
                                  display: "flex",
                                  justifyContent: "space-around",
                                  alignItems: "center"
                                }}
                              >
                                <p style={{ margin: "0", padding: "0" }}>
                                  <b>{"MAGNUM CLOTHING PVT LTD"} </b>
                                </p>
                                <p style={{ margin: "0", padding: "0" }}>
                                  <b>
                                    {column.date ? (
                                      <Fragment>DATED: {val.date}</Fragment>
                                    ) : (
                                        ""
                                      )}
                                  </b>
                                </p>
                              </div>
                            </td>
                          </tr>
                          <tr class="border-0">
                            {/* <td
                              rowspan="12"
                              colSpan="2"
                              className="qr-wrap text-center"
                            >
                              <div
                                style={{
                                  // margin: "auto",
                                  maxheight: "50px",
                                  maxWidth: "50px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  margin: "auto"
                                }}
                              >
                                <QrCode qr={val.qr} />
                              </div>
                              <div class="text-center f-15">
                                {column.styleNo && (
                                  <b>
                                    STYLE NO: <br /> | {val.styleNo} |
                                  </b>
                                )}
                              </div>
                              <div class="text-center f-15">
                                <b>{val.date}</b>
                              </div>
                              <br />
                            </td>  */}
                            <tr className="border-0 l-height">
                              <td
                                className=""
                                style={{
                                  width: "60%",
                                  paddingRight: "0"
                                }}
                              >

                                {/* <div class="text-center f-15">
                                {column.styleNo && (
                                  <b>
                                    STYLE NO: <br /> | {val.styleNo} |
                                  </b>
                                )}
                              </div> */}

                                <p>
                                  {column.styleNo ? (
                                    <Fragment>
                                      <b>STYLE NO: </b>
                                      {val.styleNo}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>

                                <p>
                                  {column.styleName ? (
                                    <Fragment>
                                      <b>STYLE NAME: </b>
                                      {val.styleName}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.sampleType ? (
                                    <Fragment>
                                      <b>SAMPLE TYPE: </b>
                                      {val.sampleType}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.fabric ? (
                                    <Fragment>
                                      <b>FABRIC: </b> {val.fabric
                                        .split(",")
                                        .map((item, index) => (
                                          <Fragment key={index}>
                                            {item.trim()}
                                            <br />
                                          </Fragment>
                                        ))}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                {/* <p>
                                  {column.fabricName ? (
                                    <Fragment>
                                      <b>FABRIC NAME: </b> {val.fabricName}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.bNumber ? (
                                    <Fragment>
                                      <b>BASE NO: </b> {val.bNumber}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.fabricOrigination ? (
                                    <Fragment>
                                      <b>FABRIC ORIGIN: </b>
                                      {val.fabricOrigination}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p> */}
                              </td>
                              <td className="">
                                <p>
                                  {column.size ? (
                                    <Fragment>
                                      <b>SIZE: </b>
                                      {val.size}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.washType ? (
                                    <Fragment>
                                      <b>WASH TYPE: </b>
                                      {val.washType}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.customer ? (
                                    <Fragment>
                                      <b>CUST/DEPT: </b>
                                      {val.customer}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.cusRef ? (
                                    <Fragment>
                                      <b>CUST REF NO: </b>
                                      {val.cusRef}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                                <p>
                                  {column.ItemNum ? (
                                    <Fragment>
                                      <b>CUST ITM NO: </b>
                                      {val.ItemNum}
                                    </Fragment>
                                  ) : (
                                      ""
                                    )}
                                </p>
                              </td>
                            </tr>
                            {/*  */}

                            {/* {tableHeaderData.map(data => {
                              if (
                                data.tableKeyName !== "qr" &&
                                data.tableKeyName !== "fabricNumber"
                              ) {
                                if (column[data.tableKeyName]) {
                                  return (
                                    <tr className="border-0">
                                      <td className="">
                                        <b>{data.tableName}:</b>
                                      </td>
                                      <td className="">
                                        {val[data.tableKeyName]}
                                      </td>
                                    </tr>
                                  )
                                } else {
                                  return (
                                    <tr className="border-0">
                                      <td className=""> :</td>

                                      <td className=""> </td>
                                    </tr>
                                  )
                                }
                              } */}
                            {/* })} */}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Fragment>
                );
              })}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PrintStylePage;


// WEBPACK FOOTER //
// ./src/components/PrintStylePage/index.js